<div class="new-static-item-container" data-cy="add-item-container">
  <div
    class="new-static-item"
    *ngFor="let option of staticItemsOptions; let i = index"
    (click)="onClickOption(option)"
    (mouseover)="onHoverItem(i)"
    [class.selected]="i === selectedIndex"
  >
    <div class="item-text-line">
      <u-icon *ngIf="option.icon" class="item-icon" [model]="{ type: 'font', value: option.icon }"></u-icon>
      <div class="item-text">{{ option?.text }}</div>
    </div>
  </div>
  <div class="file-upload-container" (mouseover)="onHoverItem(fileItemIndex)" [class.selected]="fileItemIndex === selectedIndex">
    <u-file-upload
      data-cy="file-upload-button"
      [label]="'File'"
      [fontIcon]="'file-empty'"
      typeElement="secondary"
      [styleType]="'text'"
      [sizeElement]="'extra-small'"
      [styles]="{ width: '135px', 'justify-content': 'flex-start' }"
      (onSelect)="onUpload($event)"
      (onError)="onUploadError($event)"
    ></u-file-upload>
  </div>
</div>
